
import React from 'react';
import { Box, Button, Checkbox, FormControlLabel, FormGroup, Link, Radio, RadioGroup, Stack, TextField, Typography } from '@mui/material';
import { PageContainer } from './PageContainer';
import { MBFooter } from '@mercedes-benz/mbui-comps';
import { useTheme } from '@emotion/react';

const PageLayout = ({ children }) => {
  const theme = useTheme();
  const [useCase, setUseCase] = React.useState(null);
  const [privacyPolicyState, setPrivacyPolicyState] = React.useState(false);

  const handleRadioChange = (event) => {
    setUseCase(event.target.value);
  }

  const handleCheckboxChange = (event) => {
    setPrivacyPolicyState(event.target.checked);
  }

  const closeContactForm = (event) => {
    document.getElementsByTagName('body')[0].className = '';
    document.firstElementChild.scrollIntoView({ behavior: 'smooth' });
  }

  const handleFormSubmit = (event) => {
    event.preventDefault();

    const formData = new FormData(event.target);
    const data = Object.fromEntries(formData.entries());

    fetch('https://prod-04.germanywestcentral.logic.azure.com:443/workflows/f4d2999bf14e4a02972af8847a28b80e/triggers/When_a_HTTP_request_is_received/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2FWhen_a_HTTP_request_is_received%2Frun&sv=1.0&sig=HGkyq2bk9jsGnZ3NwZB24Qk8YGvpZKkLSdY13WAQ5GE', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
      .then(res => {
        if (res.ok) {
          alert('Thank you for your inquiry. Our sales team will contact you soon.');
          event.target.reset();
          setUseCase(null);
          setPrivacyPolicyState(false);
        } else {
          alert('There was an error submitting the form. Please try again later or contact the data team.');
        }
      })
      .then(() => {
        closeContactForm();
      });
  }

  return (
    <Box className="PageLayout-root">
      {/*<PageNavBar />*/}
      <Box component="form" onSubmit={handleFormSubmit} className="ContactForm-form">
        <Typography variant="h2" component="h1" className="PageTitle">Mercedes-Benz Energy Storage System</Typography>
        <Stack direction="row" className="PageLayout-content">
          <PageContainer>{children}</PageContainer>
          <Box className="ContactForm-root" id="contactForm">
            <Box className="ContactForm-wrapper">
              <Typography variant='h4' className="ContactForm-headline">Contact our Sales team</Typography>
              <Typography variant='body1' component='p' gutterBottom>
                Which use case is your primary purpose for the Battery storage system?
              </Typography>
              <RadioGroup name='use_case' value={useCase} onChange={handleRadioChange}>
                <FormControlLabel control={<Radio disableRipple />} value='peak_shaving' label="Peak Shaving / Atypical Grid use" />
                <FormControlLabel control={<Radio disableRipple />} value='self_consumption' label="Self consumption optimization" />
                <FormControlLabel control={<Radio disableRipple />} value='energy_price_optimization' label="Energy Price optimization" />
                <FormControlLabel control={<Radio disableRipple />} value='trading' label="Trading" />
                <FormControlLabel control={<Radio disableRipple />} value='mixed_use' label="None from above / mixed use case" />
              </RadioGroup>
              <TextField label='Purpose description' name='purpose' variant="filled" fullWidth margin="normal" size='small' multiline minRows={3} maxRows={10} />
              <FormGroup sx={{ marginBottom: `${theme.spacing(2)}` }}>
                <TextField label='Company' name='company' required variant="filled" fullWidth margin="normal" size='small' multiline minRows={1} maxRows={3} />
                <TextField label='Contact person' name='contact_person' required variant="filled" fullWidth margin="normal" size='small' multiline minRows={1} maxRows={3} />
                <TextField label='Email address' name='email' type='email' required variant="filled" fullWidth margin="normal" size='small' multiline minRows={1} maxRows={3} />
                <TextField label='Phone number (optional)' type='tel' name='phone' variant="filled" fullWidth margin="normal" size='small' multiline minRows={1} maxRows={3} />
              </FormGroup>
              <FormGroup>
                <FormControlLabel control={<Checkbox disableRipple required />} name='privacy_policy' value={1} checked={privacyPolicyState} onChange={handleCheckboxChange} labelPlacement='end' label={<span>I confirm that I have read the <Link href="https://group.mercedes-benz.com/privacy/" target="_blank" rel="noopener noreferrer">privacy policy</Link>. My personal information will only be used for the purpose of this inquiry.</span>} />
              </FormGroup>
              <Stack direction="row" spacing={2} sx={{ marginBottom: `${theme.spacing(4)}`, marginTop: `${theme.spacing(2)}` }}>
                <Button type='submit' variant='contained' color='primary'>Submit</Button>
                <Button type='reset' variant='outlined' color='secondary' onClick={closeContactForm}>Cancel</Button>
              </Stack>
            </Box>
          </Box>
        </Stack>
      </Box>

      <MBFooter
        providerInfoLink="https://group.mercedes-benz.com/provider/"
        legalNoticeInfoLink="https://group.mercedes-benz.com/provider/"
        privacyProtectionInfoLink="https://group.mercedes-benz.com/privacy/"
        leftContent={
          <Box className="Footer-disclaimer" sx={{ paddingRight: '16px', flex: '1 1 70%' }}>
            <Typography variant='body2' component='p'>Currently this system does not comply with statutory regulations and is not yet available on the market neither put into service until it has been brought into conformity.</Typography>
            <Typography variant='body2' component='p' sx={{ paddingTop: '16px' }}>Version: {
              (new Date()).toLocaleDateString('en-GB', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
              })
            }</Typography>
          </Box>
        }
        rightsReservedText={`\u00a9 ${new Date().getFullYear()} Mercedes-Benz Group AG. All rights reserved.`}
        rightContent={
          <Box className="Address" sx={{ justifySelf: 'flex-start', paddingLeft: '16px', flex: '1 1 40%' }}>
            <Typography variant='body2' component='p'>Mercedes-Benz Energy GmbH</Typography>
            <Typography variant='body2' component='p'>Sch&uuml;costraße 6</Typography>
            <Typography variant='body2' component='p'>01900 Großr&ouml;hrsdorf</Typography>
            <Typography variant='body2' component='p'>Germany</Typography>
          </Box>
        }
      ></MBFooter>
    </Box>
  );
};

PageLayout.propTypes = {};

export { PageLayout };
